module.exports = __webpack_public_path__ + "b6c566bf67da869c2e474f19bfff8999.png";